import { createElement } from 'react'
import {
  Beer,
  Building2,
  CloudRain,
  Cog,
  Construction,
  Cross,
  Dot,
  Dumbbell,
  Factory,
  GraduationCap,
  Home,
  Hotel,
  KeySquare,
  School,
  ShoppingBag,
  Store,
  Tv2,
  Utensils,
  Waves,
} from 'lucide-react'
import { GiPlantWatering } from 'react-icons/gi'
import { MdOutlineStadium } from 'react-icons/md'
import { RiHospitalLine } from 'react-icons/ri'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

interface Props {
  sector?: string
  color?: string
  size?: number
  occupants?: number | null
}

interface IconProps {
  [key: string]: any
}

const SectorIcon = ({ sector = 'default', color = '#0d6efd', size = 20, occupants = 0 }: Props) => {
  const ICONS: IconProps = {
    bar: Beer,
    cinema: Tv2,
    construction_site: Construction,
    default: Dot,
    gym: Dumbbell,
    hospital: RiHospitalLine,
    hotel: Hotel,
    industrial: Factory,
    irrigation: GiPlantWatering,
    manufacturing: Factory,
    nursing_home: Cross,
    office: Building2,
    pool: Waves,
    rain_water_harvester: CloudRain,
    real_estate: KeySquare,
    residential: Home,
    restaurant: Utensils,
    school: School,
    service_station: Cog,
    shopping_center: ShoppingBag,
    shop: Store,
    stadium: MdOutlineStadium,
    student_accommodation: GraduationCap,
  }

  const iconProps = {
    color,
    size,
  }

  const formatedSector = sector.replace(' ', '_').toLowerCase()

  const iconName = Object.keys(ICONS)
    .filter((icon): boolean => icon === formatedSector)
    .toString()

  return iconName && iconName !== 'default' ? (
    <OverlayTrigger
      delay={{ hide: 450, show: 300 }}
      overlay={(props: any) => (
        <Tooltip {...props}>{`${sector} ${occupants && occupants > 0 ? '(' + occupants : ''}  ${
          occupants && occupants > 1 ? 'occupants)' : ''
        } ${occupants && occupants === 1 ? 'occupant)' : ''}`}</Tooltip>
      )}
      placement="bottom"
    >
      <span>{createElement(ICONS[iconName], iconProps)}</span>
    </OverlayTrigger>
  ) : (
    <></>
  )
}

export default SectorIcon
